<template>
  <v-select
    label="Période"
    v-model="period"
    :items="periods"
    :light="light"
    :dark="dark"
  ></v-select>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { STATS_SET_PERIOD } from '@/store/actions/stats';

export default {
  name: 'PeriodSelector',

  props: [
    'light',
    'dark'
  ],

  data: () => ({
    periods: [
      { text: 'Jour', value: 'day' },
      { text: 'Semaine', value: 'week' },
      { text: 'Mois', value: 'month' },
      { text: 'Année', value: 'year' }
    ]
  }),

  computed: {
    ...mapState({
      __period: state => state.stats.period
    }),
    period: {
      get () {
        return this.__period;
      },
      set (value) {
        this.setPeriod(value);
      }
    }
  },

  methods: {
    ...mapActions({
      setPeriod: STATS_SET_PERIOD
    })
  }
};
</script>

<style lang="scss" scoped>
</style>
